module.exports = __webpack_public_path__ + "fonts/icomoon.0ab4468.eot";